import {
  AfterViewInit,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MediaImageComponent } from '@nx-massaud/media/ui/image';
import { TermAward } from '@madeinlune/massaud-types';

@Component({
  selector: 'msd-det-ui-awards',
  standalone: true,
  imports: [CommonModule, MediaImageComponent],
  template: `
    <ng-container *ngIf="awards">
      <ng-template ngFor [ngForOf]="awards" let-award>
        <i2l-media-image [image]="award.media"></i2l-media-image>
      </ng-template>
    </ng-container>
  `,
  styleUrls: ['./awards.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class AwardsComponent implements AfterViewInit {
  @Input()
  awards: TermAward[] | undefined;

  ngAfterViewInit(): void {
    console.log('this.awards', this.awards);
  }
}
